// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomInput_wrapper__yH50j","input":"CustomInput_input__mwf4P","icon":"CustomInput_icon__jDaLs","delete":"CustomInput_delete__Q090z","hidden":"CustomInput_hidden__HuHuy"};